import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/Button";
import { ROUTES } from "@/utils/constants";
import { ArrowLeftIcon } from "lucide-react";
import { useRouter } from "next/router";
const backToHomeContent = {
  text: "Go Back Home"
};
export const BackToHomeButton = () => {
  const $ = _c(5);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = () => {
      router.replace(ROUTES.HOME);
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleGoBackHome = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArrowLeftIcon />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== handleGoBackHome) {
    t2 = <Button onClick={handleGoBackHome} icon={t1} iconPosition="left">{backToHomeContent.text}</Button>;
    $[3] = handleGoBackHome;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};